<ng-container *ngIf="bootstrap$ | async as bootstrap">
  <smsir-alert
    *ngIf="alertMessage || cancellation"
    class="!tw-mb-3 tw-block tw-w-full"
    type="info"
    [showIcon]="true"
    [message]="alertMessage || ('متن (' + cancellation + ') به‌طور خودکار به انتهای پیامک شما اضافه می‌گردد.')"
  ></smsir-alert>
  <div class="text-builder-wrapper">
    <div
      *ngIf="textBuilderType !== textBuilderTypeEnum.Textarea"
      class="text-builder-params"
      [class.box-container]="!hasTransparentBackground">

      <div *ngIf="textBuilderType === textBuilderTypeEnum.TemplateAndParametric ||
                textBuilderType === textBuilderTypeEnum.Template ||
                textBuilderType === textBuilderTypeEnum.Parametric"
           class="personalize-box">

        <smsir-tabs
          *ngIf="textBuilderType === textBuilderTypeEnum.TemplateAndParametric"
          class="!tw-mb-3"
          [value]="activeTab"
          (valueChange)="switchTab($event)"
          variant="fill"
        >
          <smsir-tab value="templates">
            <span tabText>پیش‌نویس‌ها</span>
          </smsir-tab>
          <smsir-tab value="personalize">
            <span tabText>شخصی‌سازی</span>
          </smsir-tab>
        </smsir-tabs>

        <h6
          *ngIf="textBuilderType === textBuilderTypeEnum.Template"
          class="!tw-m-0 !tw-mb-3 smsir-label-sm"
        >
          پیش‌نویس‌ها
        </h6>

        <div
          *ngIf="textBuilderType === textBuilderTypeEnum.Parametric"
          class="tw-flex tw-min-h-0 tw-flex-col tw-gap-3"
        >
          <h6 class="!tw-m-0 smsir-label-sm tw-text-[rgb(var(--text-section-label))]">
            شخصی‌سازی
          </h6>

          <div class="personalize">
            <div class="tw-flex tw-flex-wrap tw-gap-2">
              <button
                *ngFor="let parameter of displayParameters"
                type="button"
                class="param-chip-btn"
                [class.url-add]="parameter.parameter === 'link'"
                [disabled]="parameter.parameter === 'link' && isShortLink"
                (mousedown)="onPersonalizeMouseDown($event, parameter)"
              >
                <smsir-label
                  [value]="parameter.parameter === 'link' ? (parameter.title ? parameter.title : parameter.parameter) : ('#' + (parameter.title ? parameter.title : parameter.parameter) + '#')"
                  variant="accent"
                  size="sm"
                ></smsir-label>
              </button>
              <p
                *ngIf="!displayParameters?.length"
                class="!tw-m-0 smsir-helper-md tw-text-[rgb(var(--text-secondary))]"
              >
                پس از آپلود فایل، پارامترهای ستون‌ها اینجا نمایش داده می‌شوند.
              </p>
            </div>
          </div>
        </div>

        <div
          *ngIf="textBuilderType === textBuilderTypeEnum.TemplateAndParametric && activeTab === 'personalize'"
          class="personalize"
        >
          <div *ngIf="isURL" class="tw-mb-3">
            <form [formGroup]="formURL" class="!tw-mt-3">
              <smsir-input-label>لطفا لینک خود را وارد کنید</smsir-input-label>
              <div class="tw-mt-1 tw-flex tw-flex-row tw-items-center tw-gap-2">
                <smsir-input-group class="tw-min-w-0 tw-flex-1">
                  <input smsirInput
                         (input)="importURL($event)"
                         [dir]="'ltr'"
                         [value]=""
                         formControlName="webURL"
                         placeholder="لطفا لینک خود را وارد کنید"
                         type="text"
                  />
                </smsir-input-group>
                <button type="button"
                        smsir-button
                        variant="secondary"
                        size="sm"
                        class="tw-shrink-0"
                        (click)="generateURL()"
                        [disabled]="!formURL.valid">
                  تبدیل
                </button>
              </div>
              <div class="hint">
                <i class="ic-linear ic-ui-essentional-info-circle !tw-text-base !tw-leading-none" aria-hidden="true"></i>
                <span>به‌صورت پیش‌فرض مقدار https در آدرس شما قرار می‌گیرد.</span>
              </div>
            </form>
          </div>
          <div class="tw-flex tw-flex-wrap tw-gap-2">
            <button
              *ngFor="let parameter of displayParameters"
              type="button"
              class="param-chip-btn"
              [class.url-add]="parameter.parameter === 'link'"
              [disabled]="parameter.parameter === 'link' && isShortLink"
              (mousedown)="onPersonalizeMouseDown($event, parameter)"
            >
              <smsir-label
                [value]="parameter.parameter === 'link' ? (parameter.title ? parameter.title : parameter.parameter) : ('#' + (parameter.title ? parameter.title : parameter.parameter) + '#')"
                variant="accent"
                size="sm"
              ></smsir-label>
            </button>
          </div>
        </div>
        <div
          *ngIf="(textBuilderType === textBuilderTypeEnum.Template || textBuilderType === textBuilderTypeEnum.TemplateAndParametric) && activeTab === 'templates'"
          class="template">
          <smsir-input-group class="!tw-mb-3">
            <input
              smsirInput
              (input)="onInput($event)"
              placeholder="جستجو..."
              type="text">
            <i class="smsir-input-group__icon ic-linear ic-design-magnifer"></i>
          </smsir-input-group>
          <div class="template-container">
            <p *ngIf="!templates || templates.length === 0" class="!tw-m-0 smsir-helper-md tw-opacity-70">
              پیش‌نویسی یافت نشد.
            </p>
            <div *ngIf="templates?.length" class="tw-flex tw-flex-wrap tw-items-center tw-gap-2">
              <button
                *ngFor="let draft of templates"
                type="button"
                class="draft-chip-btn"
                (click)="selectTemplate(draft)"
              >
                <smsir-label
                  [value]="draft.title"
                  variant="accent"
                  size="sm"
                ></smsir-label>
              </button>
            </div>
          </div>
        </div>

      </div>

      <div *ngIf="textBuilderType === textBuilderTypeEnum.FastSend" class="personalize-box">
        <h6 class="!tw-m-0 !tw-mb-3 smsir-label-sm">پارامترهای شخصی‌سازی</h6>
        <div class="fast-send-details">
          <p>این پارامترها توسط شما و باتوجه به نیازتان ایجاد می‌شوند.</p>
          <p>
            در صورتی که مایل به استفاده از اسامی متغیر در قالب نوشتاری هستید، می‌توانید کلمات موردنظر خود را در داخل
            نماد # قرار دهید
          </p>
          <p>مانند: #contacts#</p>
          <p>
            <strong>توجه: </strong>
            هر متغیر پس از جای‌گذاری می‌تواند حداکثر ۲۵ کاراکتر را در خود جای دهد. در صورت نیاز به کاراکترهای بیشتر،
            لطفاً با پشتیبانی در ارتباط باشید.
          </p>
        </div>
        <smsir-alert
          class="!tw-mt-2"
          type="info"
          message="قالب باید دارای متغیر باشد."
        ></smsir-alert>
        <smsir-alert
          class="!tw-mt-2"
          type="info"
          message="سایت ذکر شده در قالب باید دارای اینماد باشد"
        ></smsir-alert>
      </div>

    </div>

    <div
      class="text-builder-textarea"
      [ngClass]="{'has-template': textBuilderType !== textBuilderTypeEnum.Textarea}"
      [class.box-container]="!hasTransparentBackground">
      <form [formGroup]="form" class="content-box">
        <smsir-input-label>{{ title }}</smsir-input-label>
        <div
          class="composer-field"
          [style.height]="heightSize ? heightSize + 'px' : null"
          [style.min-height]="(heightSize || 280) + 'px'">
          <textarea #message
                    (errorStatusChanged)="errorStatusChanged($event)"
                    (ngModelChange)="onMessageTextChange()"
                    (select)="saveSelection()"
                    (click)="saveSelection()"
                    (keyup)="saveSelection()"
                    (mouseup)="saveSelection()"
                    (input)="saveSelection()"
                    [autoGeneratedError]="false"
                    [maxLength]="hasDoubleChar ? 932 : 2136"
                    [ngClass]="{
                    'input-error': !!form.controls.text.hasError('maxLength'),
                    'textarea-text-show': !isTextChanging,
                    'is-emojifying': isTextChanging
                   }"
                    [class.tw-pointer-events-none]="isTextChanging"
                    class="composer-field__input !tw-mb-0 !tw-pb-[4.5rem]"
                    [needSpace]="true"
                    appFormError
                    dir="rtl"
                    formControlName="text"
                    placeholder="متن پیام خود را اینجا بنویسید..."
                    rows="10"
                    smsirTextarea
                    fluid
                    [fill]="!!heightSize"
          >
               </textarea>
          <div
            *ngIf="isTextChanging"
            dir="rtl"
            class="tw-pointer-events-none tw-absolute tw-inset-px tw-z-10 tw-flex tw-flex-col tw-items-stretch
                   tw-justify-start tw-gap-3 tw-rounded-[calc(var(--smsir-radius-lg)-1px)] tw-p-6"
            role="status"
            aria-busy="true"
            aria-label="در حال شکلک گذاری">
            <smsir-skeleton class="tw-h-3 tw-w-11/12 tw-shrink-0 tw-rounded-full"></smsir-skeleton>
            <smsir-skeleton class="tw-h-3 tw-w-full tw-shrink-0 tw-rounded-full"></smsir-skeleton>
            <smsir-skeleton class="tw-h-3 tw-w-4/5 tw-shrink-0 tw-rounded-full"></smsir-skeleton>
            <smsir-skeleton class="tw-h-3 tw-w-2/3 tw-shrink-0 tw-rounded-full"></smsir-skeleton>
          </div>

          <div class="composer-footer">
            <div *ngIf="showCounter" class="composer-footer__stats">
              <smsir-label
                variant="accent"
                size="lg"
                [value]="localSmsLen + ' / ' + container + ' | ' + smsCount + ' پیامک'"
              ></smsir-label>

              <div
                *ngIf="showFloatingActions"
                class="composer-footer__emoji-actions tw-h-9"
              >
                <button
                  type="button"
                  class="composer-footer__emoji-action tw-size-9"
                  aria-label="بازگشت"
                  smsirTooltip
                  TooltipTitle="بازگشت"
                  TooltipPosition="top"
                  TooltipArrowPosition="center"
                  TooltipType="primary"
                  TooltipTrigger="hover"
                  (click)="rejectChanges()"
                >
                  <i class="ic-linear ic-arrows-action-undo-left tw-text-xl tw-leading-none" aria-hidden="true"></i>
                </button>
                <smsir-divider type="vertical" length="var(--smsir-spacing-lg)"></smsir-divider>
                <button
                  type="button"
                  class="composer-footer__emoji-action tw-size-9"
                  aria-label="تایید تغییرات"
                  smsirTooltip
                  TooltipTitle="تایید تغییرات"
                  TooltipPosition="top"
                  TooltipArrowPosition="center"
                  TooltipType="primary"
                  TooltipTrigger="hover"
                  (click)="acceptChanges()"
                >
                  <i class="ic-linear ic-ui-essentional-check-circle tw-text-xl tw-leading-none" aria-hidden="true"></i>
                </button>
              </div>
            </div>

            <div *ngIf="bootstrap.settingsData.isXMAEnabled" class="composer-footer__actions">
              <button
                id="emoji"
                type="button"
                smsir-button
                [variant]="'tertiary'"
                size="xs"
                [iconOnly]="isMobile"
                [attr.aria-label]="'شکلک‌گذاری'"
                [disabled]="isTextChanging"
                (click)="emojifyText()"
              >
                <i class="ic-linear ic-ui-essentional-home-smile-angle tw-text-xl"></i>
                <span *ngIf="!isMobile">شکلک‌گذاری</span>
              </button>

              <button
                *ngIf="!isMobile"
                type="button"
                smsir-button
                [variant]="'secondary'"
                size="sm"
                [attr.aria-label]="'دستیار هوشمند ایکسما'"
                [disabled]="isTextChanging"
                (click)="openTextGenerationModal()"
              >
                دستیار هوشمند ایکسما
                <i class="ic-duotone ic-weather-stars-2"></i>
              </button>

              <button
                *ngIf="isMobile"
                type="button"
                smsir-button
                [variant]="'secondary'"
                size="xs"
                iconOnly
                [attr.aria-label]="'دستیار هوشمند ایکسما'"
                [disabled]="isTextChanging"
                (click)="openTextGenerationModal()"
              >
                <i class="ic-duotone ic-weather-stars-2"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
      <div class="error-place">
        <div class="tw-text-left">
          <smsir-input-hint *ngIf="errorMsg" error>{{ errorMsg }}</smsir-input-hint>
          <smsir-input-hint *ngIf="form.controls.text.hasError('maxLength')" error>
            تعداد کارکتر وارد شده بیشتر از مقدار مجاز می باشد
          </smsir-input-hint>
        </div>
      </div>

      <ng-content select="[textBuilderAttachment]"></ng-content>
    </div>
  </div>
</ng-container>
